import { Redirect } from 'react-router-dom';
import { SUB_ADMIN_DASHBOARD } from '../../config/constants/routePathConstants.js';

export const RedirectToAdminDashboard = () => {
  return <Redirect to={SUB_ADMIN_DASHBOARD} />;
};

